import { useIsBenefitEngineAdmin } from "hooks/useBenefitEngineAdmin";
import useDocumentTitle from "hooks/useDocumentTitle";
import { TabPanel, TabView } from "primereact/tabview";

import { LineTypesTab } from "./LineTypesTab";
import { PayerOverridesTab } from "./PayerOverridesTab";

/**
 * CLE-2792 — Eligibility: the payer-agnostic settings behind every eligibility check.
 *
 * A TABBED page. The tabs are not decoration: line types and payer overrides both belong to
 * eligibility as a whole rather than to one account or one payer, and giving the first one a page of
 * its own would have meant moving it when the second arrived — which it now has.
 *
 * Payer overrides come first and open by default (Mike, 2026-09-14): they are the tab edited day
 * to day — a payer reporting the wrong copay is a recurring event — while a line type definition
 * is written once per payer wording and then left alone. The engine reads them in the other order
 * (line selection first, then the override on top of it); the order the engine runs them is not
 * the order a person needs them.
 *
 * ⚠️ VISIBLE TO THE PEOPLE RUNNING THE CUTOVER while the engine is mid-cutover — see
 * `useBenefitEngineAdmin`. The route is ALSO super-admin protected; this hides a screen, it does
 * not protect an endpoint.
 */
export function EligibilityPage() {
  useDocumentTitle("Eligibility");
  const isEngineAdmin = useIsBenefitEngineAdmin();

  if (!isEngineAdmin) return null;

  return (
    <div className="p-4" data-testid="eligibilityPage">
      <h2 className="m-0 mb-3">Eligibility</h2>
      <TabView data-testid="eligibilityPage.tabs">
        <TabPanel header="Payer overrides">
          <PayerOverridesTab />
        </TabPanel>
        <TabPanel header="Line types">
          <LineTypesTab />
        </TabPanel>
      </TabView>
    </div>
  );
}
